/* Skyla Rose try-on nudge
   1. Circles the "Try on" button with a hand-drawn ring + arrow and a short note.
   Shows once per visit; never again once they've used the try-on.
   (Chat prompts after try-on are switched off for now.) */
(function () {
  if (window.__saroNudge) return;
  window.__saroNudge = true;

  var KEY_SEEN = 'saroTryNudge', KEY_TRIED = 'saroTriedOn';

  function store(type, k, v) {
    try {
      var s = type === 'l' ? window.localStorage : window.sessionStorage;
      if (v === undefined) return s.getItem(k);
      s.setItem(k, v);
    } catch (e) { return null; }
  }

  var layer, ring, ellipse, arrow, card, eyebrowEl, textEl, yesBtn, noBtn, current = null, raf = 0;

  function build() {
    layer = document.createElement('div');
    layer.className = 'saro-nudge';
    layer.hidden = true;
    layer.innerHTML =
      '<svg class="saro-nudge__ring" aria-hidden="true"><ellipse pathLength="1"/></svg>' +
      '<svg class="saro-nudge__arrow" viewBox="0 0 44 44" aria-hidden="true">' +
        '<path d="M8 40C30 38 36 22 36 6"/><path d="M30 13L36 5L42 13"/></svg>' +
      '<div class="saro-nudge__card" role="dialog" aria-live="polite">' +
        '<button type="button" class="saro-nudge__x" aria-label="Close">&times;</button>' +
        '<p class="saro-nudge__eyebrow"></p><p class="saro-nudge__text"></p>' +
        '<div class="saro-nudge__btns"><button type="button" class="saro-nudge__yes"></button>' +
        '<button type="button" class="saro-nudge__no"></button></div></div>';
    document.body.appendChild(layer);
    ring = layer.querySelector('.saro-nudge__ring');
    ellipse = ring.querySelector('ellipse');
    arrow = layer.querySelector('.saro-nudge__arrow');
    card = layer.querySelector('.saro-nudge__card');
    eyebrowEl = layer.querySelector('.saro-nudge__eyebrow');
    textEl = layer.querySelector('.saro-nudge__text');
    yesBtn = layer.querySelector('.saro-nudge__yes');
    noBtn = layer.querySelector('.saro-nudge__no');

    yesBtn.addEventListener('click', function () {
      var f = current && current.onYes; hide(); if (f) f();
    });
    function dismiss() { var f = current && current.onNo; hide(); if (f) f(); }
    noBtn.addEventListener('click', dismiss);
    layer.querySelector('.saro-nudge__x').addEventListener('click', dismiss);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && current) dismiss(); });
  }

  function rectOf(el) {
    if (!el) return null;
    var r = el.getBoundingClientRect();
    return (r.width || r.height) ? r : null;
  }

  function place() {
    if (!current) return;
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var cw = Math.min(300, vw - 32);
    card.style.width = cw + 'px';
    var ch = card.offsetHeight;
    var t = typeof current.target === 'function' ? current.target() : current.target;
    var r = rectOf(t);

    if (!r) { // no target: gentle card near the bottom, clear of the chat bubble
      ring.style.display = 'none'; arrow.style.display = 'none';
      var top = vh - ch - 96, b = bubbleRect();
      if (b && b.top - ch - 16 < top) top = b.top - ch - 16;
      card.style.left = ((vw - cw) / 2) + 'px';
      card.style.top = Math.max(16, top) + 'px';
      return;
    }

    ring.style.display = ''; arrow.style.display = '';
    var w = r.width + 28, h = r.height + 20;
    ring.setAttribute('width', w); ring.setAttribute('height', h);
    ring.style.left = (r.left - 14) + 'px'; ring.style.top = (r.top - 10) + 'px';
    ellipse.setAttribute('cx', w / 2); ellipse.setAttribute('cy', h / 2);
    ellipse.setAttribute('rx', w / 2 - 1.5); ellipse.setAttribute('ry', h / 2 - 1.5);

    var below = (r.bottom + 12 + 44 + ch + 12 <= vh) || (r.top - 12 - 44 - ch < 12);
    var right = (r.left + r.width / 2) > vw * 0.55;
    var tipX = r.left + r.width / 2;
    var tipY = below ? r.bottom + 12 : r.top - 12;
    var aL = tipX - (right ? 8 : 36), aT = tipY - (below ? 5 : 39);
    arrow.style.left = aL + 'px'; arrow.style.top = aT + 'px';
    arrow.style.transform = 'scale(' + (right ? -1 : 1) + ',' + (below ? 1 : -1) + ')';

    var tailX = aL + (right ? 36 : 8);
    var cl = right ? tailX - cw + 28 : tailX - 28;
    cl = Math.max(16, Math.min(vw - 16 - cw, cl));
    card.style.left = cl + 'px';
    card.style.top = (below ? aT + 48 : aT - ch - 4) + 'px';
  }

  function loop() { place(); raf = requestAnimationFrame(loop); }

  // Don't stack on top of another popup (e.g. the Klaviyo sign-up form): wait until it's closed
  function otherPopupOpen() {
    var els = document.querySelectorAll('[aria-modal="true"], [role="dialog"]');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (layer && layer.contains(e)) continue;
      if (e.closest('.saro-tryon')) continue;
      var r = e.getBoundingClientRect();
      var onScreen = r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight;
      var cs = getComputedStyle(e);
      if (onScreen && r.width > 120 && r.height > 120 && cs.visibility !== 'hidden' && cs.opacity !== '0') return true;
    }
    return false;
  }

  function show(o) {
    if (!layer) build();
    current = o;
    eyebrowEl.textContent = o.eyebrow || '';
    eyebrowEl.style.display = o.eyebrow ? '' : 'none';
    textEl.textContent = o.text;
    yesBtn.textContent = o.yes || '';
    yesBtn.style.display = o.yes ? '' : 'none';
    noBtn.textContent = o.no || 'Close';
    layer.classList.remove('is-in');
    layer.hidden = false;
    cancelAnimationFrame(raf); loop();
    var shownObj = o;
    requestAnimationFrame(function () { requestAnimationFrame(function () { layer.classList.add('is-in'); }); });
    setTimeout(function () { if (current === shownObj) { place(); layer.classList.add('is-in'); } }, 120);
  }

  function hide() {
    current = null;
    cancelAnimationFrame(raf);
    if (!layer) return;
    layer.classList.remove('is-in');
    setTimeout(function () { if (!current) layer.hidden = true; }, 350);
  }

  /* ---------- Shopify Inbox (only used to keep notes clear of the chat bubble) ---------- */
  function chatHost() { return document.querySelector('shopify-chat, #ShopifyChat, inbox-online-store-chat'); }
  // Inbox nests its button inside shadow roots, so search through every layer
  function deepAll(root, out) {
    out = out || [];
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      out.push(els[i]);
      if (els[i].shadowRoot) deepAll(els[i].shadowRoot, out);
    }
    return out;
  }
  function chatToggle(host) {
    if (!host) return null;
    var all = deepAll(host.shadowRoot || host);
    var sels = ['button.activator', 'button.chat-toggle', '.chat-toggle', 'button[aria-label*="chat" i]'];
    for (var s = 0; s < sels.length; s++) {
      for (var i = 0; i < all.length; i++) { if (all[i].matches && all[i].matches(sels[s])) return all[i]; }
    }
    return null;
  }
  function bubbleRect() {
    var t = chatToggle(chatHost());
    return rectOf(t);
  }

  /* ---------- Try-on flow ---------- */
  function init() {
    var wrap = document.querySelector('.saro-tryon');
    if (!wrap) return;
    var btn = wrap.querySelector('.saro-tryon__open');
    var overlay = wrap.querySelector('.saro-tryon__overlay');
    if (!btn || !overlay) return;

    var opened = false, shown = false;
    var isOpen = function () { return !overlay.hidden; };

    btn.addEventListener('click', function () { opened = true; store('l', KEY_TRIED, '1'); hide(); });

    if (store('s', KEY_SEEN) || store('l', KEY_TRIED)) return;

    function showTry() {
      if (shown || opened || isOpen()) return;
      if (otherPopupOpen()) return setTimeout(showTry, 1500);
      shown = true;
      store('s', KEY_SEEN, '1');
      show({
        target: btn,
        eyebrow: 'New · Virtual try-on',
        text: 'Did you know you can try this piece on? Upload a photo and see it on in seconds 🤍',
        yes: 'Try it on', no: 'Maybe later',
        onYes: function () { btn.click(); }
      });
    }
    function inView() {
      var r = btn.getBoundingClientRect();
      return r.width && r.top > 60 && r.bottom < window.innerHeight - 60;
    }

    setTimeout(function () {
      if (inView()) return showTry();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); setTimeout(showTry, 900); }
        }, { threshold: 1, rootMargin: '-60px 0px -60px 0px' });
        io.observe(btn);
      }
      setTimeout(function toast() { // never scrolled to it: offer a gentle "show me"
        if (shown || opened || current) return;
        if (otherPopupOpen()) return setTimeout(toast, 1500);
        shown = true;
        store('s', KEY_SEEN, '1');
        show({
          eyebrow: 'New · Virtual try-on',
          text: 'Did you know you can try this piece on? Upload a photo and see it on in seconds 🤍',
          yes: 'Show me', no: 'Maybe later',
          onYes: function () {
            btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function () { shown = false; showTry(); }, 800);
          }
        });
      }, 15000);
    }, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
